export default "<div>{{ GetInterventionType(id) }}</div>";